import FetchCalculations from './FetchCalculations';
import updateCalculations from '../function/UpdateCalculations';

async function FetchCalculationsMain(inputs, result, setResult, options) {
  try {
    const calculationList = updateCalculations(inputs, options, result);
    if (!calculationList) return;

    const resultCalc = await FetchCalculations(inputs, calculationList);
    setResult(resultCalc);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export default FetchCalculationsMain;
